import { ReactElement } from "react";
import Markdown from "react-markdown";
import { CodeBlock } from "@twilio-paste/core/code-block";
import { InlineCode } from "@twilio-paste/core/inline-code";
import { SnippetLanguages } from "@twilio-paste/core/syntax-highlighter-library";
import { Anchor } from "@twilio-paste/core/anchor";

const MessageMarkdown = ({ markdown }: { markdown: string }): ReactElement => {
  return (
    <Markdown
      components={{
        code({ children, className }) {
          const match = /language-(\w+)/.exec(className || "");
          const language = match ? match[1] : "";
          const code = children?.toString();

          if (!code) {
            /**
             * Returning 'null' is expected for react-markdown if there's no value to return.
             * Please do not return undefined here
             */
            return null;
          }

          const isInLine = !code.includes("\n");
          if (isInLine) {
            return <InlineCode>{code}</InlineCode>;
          }

          return (
            <CodeBlock
              language={language as SnippetLanguages}
              code={code}
              maxLines={10}
            />
          );
        },
        a({ children, href }) {
          if (!href) {
            return null;
          }
          return (
            <Anchor href={href} showExternal>
              {children?.toString() || ""}
            </Anchor>
          );
        },
      }}
    >
      {markdown}
    </Markdown>
  );
};

export default MessageMarkdown;
